<template>
  <b-modal
    :active.sync="active"
    has-modal-card
  >
    <section>
      <div class="modal-bg">
        <b-field
          v-if="cardIds.length > 0"
          label="Список карток:"
        >
          <b-input
            placeholder="Текст смс"
            :value="cardIds.join(', ')"
            type="textarea"
            disabled
          />
        </b-field>

        <b-field
          v-else
          label="Відправити для номерів:"
        >
          <div>
            <b-switch v-model="isLangEnOnly">
              {{ isLangEnOnly ? 'EN' : 'UA' }}
            </b-switch>
          </div>
        </b-field>

        <b-field>
          <b-input
            placeholder="Текст смс"
            v-model="message"
            type="textarea"
          />
        </b-field>

        <div class="control">
          <button class="button is-link" @click="submit">
            Відправити
          </button>
        </div>
      </div>
    </section>
  </b-modal>
</template>

<script>
import { api } from "@/api";

export default {
  props: ['cards'],

  data () {
    return {
      isLangEnOnly: false,
      message: ''
    }
  },

  computed: {
    active: {
      get () {
        return true
      },

      set () {
        this.close()
      }
    },

    cardIds () {
      return this.cards.map(({ id }) => id)
    }
  },

  methods: {
    async submit () {
      if (this.message.length < 3) {
        this.showSnackBar('Введіть більше символів')

        return
      }

      try {
        const data = {
          message: this.message
        }

        if (this.cardIds.length === 0) {
          data.en = this.isLangEnOnly
        } else {
          data.card_ids = this.cardIds
        }

        await api({
          method: 'post',
          point: 'sms/send',
          data
        })

        this.showSnackBar('Відправлено')

        this.close()
      } catch {
        this.showSnackBar('Помилка відправки')
      }
    },

    showSnackBar(message) {
      this.$buefy.snackbar.open({
        duration: 5000,
        message,
        type: "is-warning",
        position: "is-bottom",
        actionText: "Ок"
      });
    },

    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
  //
</style>
